import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
const ServiceCard = ({ title, description, images }) => {
  const navigate = useNavigate();
  const [translateX, setTranslateX] = useState(0);
    const speed = 0.3;
    useEffect(() => {
    const interval = setInterval(() => {
      setTranslateX((prev) => (prev <= -images.length * 200 ? 0 : prev - speed));
    }, 20);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="max-w-4xl mx-auto p-6 rounded-2xl my-8">

      <h2 className="text-3xl font-bold mb-4 text-center">{title}</h2>
      <p className="text-gray-700 text-lg mb-6 text-center">{description}</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="overflow-hidden w-full bg-gray-100 py-1">
        <div
          className="flex items-center flex-nowrap gap-8"
          style={{
            display: "flex",
            flexWrap: "nowrap",
            whiteSpace: "nowrap",
            transform: `translateX(${translateX}px)`,
            transition: "transform 0s linear",
          }}
        >
          {[...images, ...images].map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Logo ${index + 1}`}
              className="mx-3"
              style={{
                // height: "100px",
                width: "120px",
                flexShrink: 0,
              }}
            />
          ))}
        </div>
      </div>
      </div>
<div style={{
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}}>
  <h3 style={{ color: "red" }}>Minimum Order: 48 pcs</h3>
</div>

      <div className="text-center">
        <button
  style={{
    marginBottom: 30,
    height: 40,
    padding: '0 15px', // horizontal padding only
    backgroundColor: "black",
    color: "white",
    // display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // border: "none",
    cursor: "pointer"
  }}
          onClick={() => navigate('/quote')}
          className="a"
        >
          Get a Quote
        </button>
      </div>
    </div>
  );
};

export default ServiceCard;
